import React from 'react';
import PageContainer from '../components/common/PageContainer';
import Layout from '../components/common/Layout';
import QaqcPlannerScreen from '../components/screens/qaqcplanner/QaqcPlannerScreen';

export default function QaqcPlanner(props) {
  return (
    <Layout headerTitle={'QAQC Planner'}>
      <PageContainer id="qaqcplanner">
        <QaqcPlannerScreen props={props} id="qaqcplanner" />
      </PageContainer>
    </Layout>
  );
}
